import clsx from 'clsx';
import { FaCheckCircle } from 'react-icons/fa';
import React from 'react';
import { IconAlertCircleFill } from './Icon';
import { cn } from '../lib/helpers.ts';

interface AlertProps {
    type: 'success' | 'error';
    children: React.ReactNode;
}

export default function Alert({ type, children }: AlertProps) {
    const icons = {
        success: FaCheckCircle,
        error: IconAlertCircleFill,
    };

    const Icon = icons[type];

    const colorVariants = {
        success: {
            bg: 'bg-green-100',
            bar: 'bg-green-500',
            icon: 'fill-green-500',
        },
        error: {
            bg: 'bg-red-100',
            bar: 'bg-red-500',
            icon: 'text-red-500',
        },
    };

    return (
        <div
            className={clsx(
                'my-4 flex items-center rounded-xl px-4 py-3 pl-0 font-medium',
                colorVariants[type].bg
            )}
        >
            <div
                className={clsx(
                    'mr-4',
                    'w-1 shrink-0 self-stretch rounded-r-md',
                    colorVariants[type].bar
                )}
            />
            <Icon
                size={20}
                className={cn('mr-3 shrink-0', colorVariants[type].icon)}
            />
            {children}
        </div>
    );
}
